export const INDUSTRY_OPTIONS = [
  'Restaurant',
  'Fast Food & Take-away',
  'Cafe & Coffee',
  'Bar & Nightclub',
  'Accommodation',
  'Hospitality',
  'Fashion & Apparel',
  'Retail',
  'Beauty & Wellness',
  'Healthcare',
  'Events & Entertainment',
  'Other',
];